import { passkeyClient } from "@better-auth/passkey/client";
import { useRouteContext } from "@tanstack/react-router";
import {
	adminClient,
	inferAdditionalFields,
	twoFactorClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
	baseURL: import.meta.env.VITE_API_URL,
	credentials: "include",
	plugins: [
		passkeyClient(),
		twoFactorClient(),
		adminClient(),
		inferAdditionalFields({
			user: {
				country: {
					type: "string",
					required: true,
				},
				companyName: {
					type: "string",
					required: false,
				},
				companyIdType: {
					type: "string",
					required: false,
				},
				companyIdValue: {
					type: "string",
					required: false,
				},
				acceptedTermsAt: {
					type: "date",
					required: false,
				},
				completedOnboardingAt: {
					type: "date",
					required: false,
				},
			},
		}),
	],
});

export function useAuth() {
	return useRouteContext({
		from: "/_app",
		select: (context) => context.authSession,
	});
}
